import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { AdvertisingListUseCaseInterface } from 'domain/usecases';

export class RemoteAdvertisingList implements AdvertisingListUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: AdvertisingListUseCaseInterface.Params,
  ): Promise<AdvertisingListUseCaseInterface.Result[]> {
    const httpResponse = await this.httpClient.request({
      url: this.url + `/${params.organizationId}/advertisement`,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
